import { ProductPlatformGroup } from './product-offering-feature.model';
import { TrafficFunnel } from './traffic-funnel.enum';

export enum Platform {
  Jobs = 'JOBS',
  Js24 = 'JS24',
  JobUp = 'JOBUP',
}

export const trafficFunnelPlatform: { [funnel in TrafficFunnel]: ProductPlatformGroup } = {
  [TrafficFunnel.JobScout24Free]: ProductPlatformGroup.JobScout24,
  [TrafficFunnel.JobScout24Purchase]: ProductPlatformGroup.JobScout24,
  [TrafficFunnel.JobScout24]: ProductPlatformGroup.JobScout24,
  [TrafficFunnel.JobsFree]: ProductPlatformGroup.Jobs,
  [TrafficFunnel.JobsPurchase]: ProductPlatformGroup.Jobs,
  [TrafficFunnel.JobUp]: ProductPlatformGroup.JobUp,
} as const;
